module.exports = __webpack_public_path__ + "static/media/alertas.f38ad1dc.png";